/**
 * @generated SignedSource<<23b1f52b25ef19ddb5f94a03ea09ed17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type tableBody_nativeIssueTable$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly key: string;
      readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "tableBody_nativeIssueTable";
};
export type tableBody_nativeIssueTable$key = {
  readonly " $data"?: tableBody_nativeIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"tableBody_nativeIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "tableBody_nativeIssueTable",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "isInlineEditingEnabled",
                  "variableName": "isInlineEditingEnabled"
                }
              ],
              "kind": "FragmentSpread",
              "name": "row_nativeIssueTable"
            }
          ]
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "902195cc42e20c6ee5be26f1dab91b32";

export default node;
